import React, { useState } from "react";

// Renders selected people as avatars and opens a picker. `peopleIndex` is a
// { _id -> {firstname, lastname, email} } map provided by the parent (Board
// page fetches employees once and passes it down).
export default function PeopleCell({ value, column, readOnly, onCommit, peopleIndex = {}, allPeople = [] }) {
  const [open, setOpen] = useState(false);
  const selected = Array.isArray(value) ? value : value ? [value] : [];
  const multiple = !!column?.settings?.multiple;

  const toggle = (uid) => {
    if (multiple) {
      const next = selected.includes(uid) ? selected.filter((x) => x !== uid) : [...selected, uid];
      onCommit(next.length ? next : null);
    } else {
      setOpen(false);
      onCommit(uid === selected[0] ? null : [uid]);
    }
  };

  return (
    <div className="cell-display people">
      <button
        type="button"
        className="people-display"
        disabled={readOnly}
        onClick={() => !readOnly && setOpen((o) => !o)}
      >
        {selected.length === 0 && <span className="placeholder">—</span>}
        {selected.map((uid) => {
          const p = peopleIndex[uid];
          const initials = p
            ? ((p.firstname?.[0] || "") + (p.lastname?.[0] || "")).toUpperCase() || "?"
            : "?";
          return (
            <span
              key={uid}
              className="avatar-chip"
              title={p ? `${p.firstname || ""} ${p.lastname || ""}`.trim() || p.email : uid}
            >
              {initials}
            </span>
          );
        })}
      </button>
      {open && (
        <>
          <div className="cell-menu-backdrop" onClick={() => setOpen(false)} />
          <div className="cell-menu people-menu">
            {allPeople.length === 0 && <div className="people-empty">No employees loaded</div>}
            {allPeople.map((p) => {
              const isSel = selected.includes(p._id);
              return (
                <button
                  key={p._id}
                  type="button"
                  className={`people-menu-item ${isSel ? "selected" : ""}`}
                  onClick={() => toggle(p._id)}
                >
                  <span className="avatar-chip">
                    {((p.firstname?.[0] || "") + (p.lastname?.[0] || "")).toUpperCase() || "?"}
                  </span>
                  <span className="people-menu-name">
                    {`${p.firstname || ""} ${p.lastname || ""}`.trim() || p.email}
                  </span>
                  {isSel && <span className="people-check">✓</span>}
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
